export default __webpack_public_path__ + "static/discuss-md-f44c06d8fa9e1b06b23b039f87803464.png";